import { ActionArgs, assign } from 'xstate';

import { FetchInitialDataResponse, HandoffCartResponse } from './cart-handoff-machine.actors';
import { CartHandoffContext } from './cart-handoff-machine.context';
import { CartHandoffEvent } from './cart-handoff-machine.events';

// ─── Internal Actions ────────────────────────────────────────────────────────

const storeOrderToken: CartHandoffAction<FetchInitialDataResponse> = assign((_, params) => {
  return {
    orderToken: params.orderToken,
  };
});

const storeConflicts: CartHandoffAction<HandoffCartResponse> = assign((_, params) => {
  return {
    conflicts: params.conflicts,
  };
});

const setIgnoreConflicts: CartHandoffAction<void> = assign(() => {
  return {
    ignoreConflicts: true,
  };
});

// ─── External Actions ────────────────────────────────────────────────────────

const trackHandoffStart: CartHandoffAction<void> = () => {};
const trackActiveBagWarning: CartHandoffAction<void> = () => {};
const trackConflictsWarning: CartHandoffAction<void> = () => {};
const trackNothingAvailable: CartHandoffAction<void> = () => {};
const trackHandoffSuccess: CartHandoffAction<HandoffCartResponse> = () => {};
const dismissToHome: CartHandoffAction<void> = () => {};
const replaceWithBag: CartHandoffAction<void> = () => {};

// ─────────────────────────────────────────────────────────────────────────────

export const CartHandoffActions = {
  storeOrderToken,
  storeConflicts,
  setIgnoreConflicts,
  trackHandoffStart,
  trackActiveBagWarning,
  trackConflictsWarning,
  trackNothingAvailable,
  trackHandoffSuccess,
  dismissToHome,
  replaceWithBag,
};

// ─── Types ───────────────────────────────────────────────────────────────────

export type CartHandoffAction<ActionParams extends Record<string, unknown> | void = void> = (
  actionArgs: ActionArgs<CartHandoffContext, CartHandoffEvent, CartHandoffEvent>,
  params: ActionParams,
) => void;
